export const SITE = {
  name: "TPLM GUYANE",
  fullName: "TPLMG SASU — TPLM Guyane",
  tagline: "Terrassement, location & logistique en Amazonie guyanaise",
  phoneDisplay: "+594 694 47 00 24",
  phoneRaw: "+594694470024",
  whatsapp: "594694470024",
  email: "ent.tplm@gmail.com",
  address: "16 rue Simon Sacapou, 97370 Maripasoula — Guyane",
  siren: "899 557 110",
  siret: "899 557 110 00017",
  tva: "FR04899557110",
  rcs: "899 557 110 R.C.S. Cayenne",
  capital: "500,00 €",
  leader: "Christopher CAZAL",
  founded: "2021",
  activity: "Travaux de terrassement courants et travaux préparatoires",
  ape: "43.12A",
};

export const WHATSAPP_URL = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
  "Bonjour TPLM Guyane, je souhaite obtenir un devis."
)}`;

export const CATEGORIES = [
  { id: "engins", label: "Engins de chantier" },
  { id: "vehicules", label: "Véhicules" },
  { id: "appartements", label: "Appartements" },
  { id: "materiaux", label: "Matériaux BTP" },
  { id: "transport", label: "Transport" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1575281923032-f40d94ef6160?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxleGNhdmF0b3IlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc5MDg3NjI1NXww&ixlib=rb-4.1.0&q=85";
